import * as React from 'react';
import {IBannerComponentProps} from "./IBannerComponentProps";
import {IBannerComponentState} from "./IBannerComponentState";
import {IMenuComponentProps} from "../menuComponent/IMenuComponentProps";

import 'src/assets/css/main.css';
import 'src/assets/css/reset.css';
import 'src/assets/css/fonts.css';

import banner from 'src/assets/images/banner.png'


export class BannerComponent extends  React.Component<IBannerComponentProps , IBannerComponentState> {


    constructor(props: IMenuComponentProps) {
        super(props)

        // Default state
        this.state = {}
    }

    public render() {

        return (
            <div>
                <section className="_imgBanner">
                    <img src={banner} alt=""/>
                </section>
                <section className="_coloredBanner">
                    <div className="container">
                        <h2 style={{cursor: 'context-menu'}}>TOP GIFS D'AUJOURD'HUI</h2>
                    </div>
                </section>
            </div>
        );

    }

}
export default BannerComponent



// WEBPACK FOOTER //
// ./src/components/bannerComponent/BannerComponent.tsx